export const formatNumber = (number: number) => {
  if (number >= 1000000) {
    return `${(number / 1000000).toFixed(0)} млн.`
  }
  if (number >= 1000) {
    return `${(number / 1000).toFixed(0)} тыс.`
  }

  return number.toString()
}

export const getFormattedValue = (value: number) => value.toLocaleString().replace(/,/g, " ")

export const formatNumberForPlaceholder = (value: number | string) => {
  if (typeof value === "number") {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  }
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

export const convertStringValueToNumber = (value: string) => parseInt(value.replace(/\s+/g, ""), 10)
